import React, { useCallback, useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
import QuizImage from './QuizImage';
import './QuizImageViewer.scss';
import minimizeIcon from '../../images/icons/minimize-icon.svg';

export default React.memo(function QuizImageViewer({ image }) {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleImage = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Escape' && isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);

  const modalContent = useMemo(() => (
    <div
      className="quiz-image-modal"
      onClick={onToggleImage}
      onKeyDown={handleKeyDown}
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="image-modal-title"
      style={{ cursor: 'pointer' }}
    >
      <div className="modal-content">
        <span
          className="close-btn"
          onClick={onToggleImage}
          onKeyDown={(e) => e.key === 'Enter' && onToggleImage()}
          tabIndex="0"
          role="button"
          autofocus={true}
          aria-label="Close image viewer"
        >
          <img src={minimizeIcon} alt="Minimize" className='close-icon' />
        </span>
        <h2 id="image-modal-title" className="visually-hidden">Expanded Quiz Image</h2>
        <QuizImage src={image} onToggleImage={onToggleImage} expanded={isOpen} />
      </div>
    </div>
  ), [isOpen, onToggleImage, handleKeyDown, image]);

  return isOpen ? createPortal(modalContent, document.getElementById('portal-override')) : <QuizImage src={image} onToggleImage={onToggleImage} />;
});
